import { useSelector } from "react-redux";
import { AppState } from "store";
import { useCheckRelations } from "components/common";
import { AuthEnums } from "models/enums";

function useInvoicePermissions() {
  const { getIsRevisor, hasRelation, getIsAuditor } = useCheckRelations();

  const getIsInvoiceAdmin = () => hasRelation(AuthEnums.PersonCompanyRelationType.InvoicesAdmin);

  const canCreateInvoices = useSelector((store: AppState) => store.auth.selectedCompany.invoiceCreator);
  const canUseInvoices = useSelector((store: AppState) => store.auth.selectedCompany.invoiceUser);
  const canUseRecurringInvoices = (canCreateInvoices || getIsAuditor()) && getIsInvoiceAdmin();

  const hasChartsPermissions = () => {
    return (canCreateInvoices || canUseInvoices) && !getIsRevisor();
  };

  return { canCreateInvoices, canUseInvoices, canUseRecurringInvoices, hasChartsPermissions, getIsInvoiceAdmin };
}

export default useInvoicePermissions;
